<div class="race-component" *ngIf="vm.race">
    <div class="race-participants">
        <div class="race-participant-list">
            <div class="race-participant clear-fix" *ngFor="let runner of vm.runners; trackBy: racePreviewTrackBy; index as indx">
                <div class="participant-cell">
                    <div class="participant-position-racecard">{{ runner.attributes.raceCardNumber }}</div>
                    <div class="participant-position-draw" *ngIf="runner.attributes.drawNumber">({{ runner.attributes.drawNumber }})</div>
                </div>
                <ms-horses-silk [src]="runner.attributes.silkUrl" [description]="runner.attributes.silkDescription"></ms-horses-silk>
                <div class="participant-cell participant-name grow">
                    <div class="participant-name-main contrast-color">{{ runner.name | msTranslate }}</div>
                    <div class="participant-name-jockey">
                        <div *ngIf="runner.attributes.jockey">{{ siteCore.horseRacing.common.JockeyNamePrefix }} {{ runner.attributes.jockey }}</div>
                        <div *ngIf="runner.attributes.trainer">
                            {{ siteCore.horseRacing.common.TrainerNamePrefix }} {{ runner.attributes.trainer }}
                        </div>
                    </div>
                </div>
                <div class="participant-odds-container">
                    <ng-container *ngIf="isOptionBet; else fixturepickTemplate">
                        <ms-hr-option-pick
                            class="odds-info ms-selectable-pick"
                            *ngIf="runner.option"
                            [option]="runner.option"
                            [optionGroup]="vm.race.optionGroups[0]"
                            [event]="vm.race"
                            [participant]="runner"
                            [pickType]="participantPickType.Win"
                            [checkSiblingSelected]="true">
                            <ms-racing-fixture-container
                                [runner]="runner"
                                [isSports]="true"
                                [isGreyhounds]="false"
                                [isSpan]="false"
                                [isOption]="false"
                                [isWinMarketOdds]="true"
                                [isActive]="runner.option.online"></ms-racing-fixture-container>
                        </ms-hr-option-pick>
                    </ng-container>
                    <ng-template #fixturepickTemplate>
                        <ms-fixture-pick
                            trackingSource="NextRaces"
                            *ngIf="runner.option"
                            [fixture]="vm.race"
                            [participant]="runner"
                            [option]="runner.option"
                            [trackingPosition]="trackingPosition"
                            [trackingOptions]="trackingOptions">
                            <ms-racing-fixture-container
                                [runner]="runner"
                                [isSports]="true"
                                [isGreyhounds]="false"
                                [isSpan]="false"
                                [isOption]="true"
                                [isWinMarketOdds]="false"
                                [isActive]="runner.isOptionActive"></ms-racing-fixture-container>
                        </ms-fixture-pick>
                    </ng-template>
                    <div class="previous-odds" *ngIf="runner.priceHistory.length">
                        <span *ngFor="let price of runner.priceHistory">{{ price | msExternalPriceFormatter }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
